export default __webpack_public_path__ + "static/media/beta-landing-asset-1.e0d1fa04.svg";